import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $processing, $done } from "services/activity/action";
import { $requesting, $success, $failure } from "services/form/action";

export const MODULE = "Manifest";
const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, "Get", (id) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/public/manifest/${id}`)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $accept = ActionCreator.Async(MODULE, "Accept", (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/public/manifest/${id}/accept`, payload)
      .then((response) => {
        dispatch($accept.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $start = ActionCreator.Async(MODULE, "Start", (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/public/manifest/${id}/start`, payload)
      .then((response) => {
        dispatch($start.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $finish = ActionCreator.Async(MODULE, "Finish", (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/public/manifest/trip/complete`, payload)
      .then((response) => {
        dispatch($finish.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $shipped = ActionCreator.Async(MODULE, "Shipped", (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/public/manifest/trip/shipped`, payload)
      .then((response) => {
        dispatch($shipped.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $pickupComplete = ActionCreator.Async(
  MODULE,
  "Pickup.Complete",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${id}/complete/pickup`,
        payload
      )
        .then((response) => {
          dispatch($pickupComplete.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $pickupDispute = ActionCreator.Async(
  MODULE,
  "Pickup.Dispute",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${id}/dispute/pickup`,
        payload
      )
        .then((response) => {
          dispatch($pickupDispute.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $shipmentComplete = ActionCreator.Async(
  MODULE,
  "Shipment.Complete",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${id}/shipment/complete`,
        payload
      )
        .then((response) => {
          dispatch($shipmentComplete.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $shipmentDispute = ActionCreator.Async(
  MODULE,
  "Shipment.Dispute",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/manifest/${id}/shipment/dispute`,
        payload
      )
        .then((response) => {
          dispatch($shipmentDispute.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);
